<template>
  <ChartCard>
    <ChartHeader label>
      <div class="d-flex align-center">
        <v-skeleton-loader
          type="text"
          min-width="164px"
          height="20px"
          class="mr-2"
        />
        <SwitchLoader />
      </div>
    </ChartHeader>
    <div class="table-loader-header">
      <div />
      <div v-for="i in 5" :key="`${i}-header`" class="py-2">
        <v-skeleton-loader
          type="text"
          width="100px"
          height="20px"
        />
      </div>
    </div>
    <div class="table-loader-row">
      <div />
      <div v-for="i in 10" :key="`${i}-total`" class="pa-2">
        <v-skeleton-loader
          type="text"
          width="60px"
          height="20px"
        />
      </div>
    </div>
    <div v-for="j in 3" :key="`${j}-row`" class="table-loader-row">
      <div class="py-1">
        <v-skeleton-loader
          type="text"
          width="180px"
          height="20px"
        />
      </div>
      <div v-for="i in 10" :key="`${i}-cell`" class="py-1 px-2">
        <v-skeleton-loader
          type="text"
          width="60px"
          height="20px"
        />
      </div>
    </div>
  </ChartCard>
</template>

<script setup>
import ChartCard from '@/components/insights/Chart/ChartCard.vue';
import ChartHeader from '@/components/insights/Chart/ChartHeader.vue';
import SwitchLoader from '@/components/insights/ProcessInsights/DemographicSurveyReport/skeletonLoaders/SwitchLoader.vue';
</script>

<style lang="less" scoped>
:deep(.v-skeleton-loader__text) {
  margin: 0 !important;
}

:deep(.switch-loader-container) {
  height: 28px;
  width: 306px;

  .switch-side-container {
    height: 16px;
  }
}

.table-loader-header {
  display: grid;
  grid-template-columns: 218px repeat(5, 1fr);
  gap: 12px;
}

.table-loader-row {
  display: grid;
  grid-template-columns: 218px repeat(10, 1fr);
  padding-left: 16px;
}
</style>
